import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CheckboxIcon = ({
  color = 'white',
  width = 10,
  marginLeft,
  marginRight,
  containerSize,
  variant,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    {variant === 'checked' ? (
      <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.5" y="1.5" width="19" height="19" rx="0.5" fill="none" stroke={getSemanticTextColor(color)} />
        <g clipPath="url(#clip0_3132_35826)">
          <rect x="2" y="2" width="18" height="18" fill="none" />
          <g clipPath="url(#clip1_3132_35826)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.4482 6.46298C15.9287 5.96112 16.753 5.91924 17.289 6.36778C17.7972 6.79348 17.8647 7.50705 17.4621 8.00738L17.3906 8.0881L10.967 14.7896C10.4739 15.3052 9.62814 15.3296 9.10084 14.8635L9.02461 14.7896L5.66787 11.2888C5.18743 10.787 5.2319 10.0171 5.76952 9.56777C6.27776 9.14283 7.04408 9.15882 7.53246 9.58757L7.61029 9.66372L9.99661 12.1501L15.449 6.46145L15.4482 6.46298Z"
              fill={getSemanticTextColor(color)}
            />
          </g>
        </g>
        <rect x="2.5" y="2.5" width="17" height="17" stroke={getSemanticTextColor(color)} />
        <defs>
          <clipPath id="clip0_3132_35826">
            <rect x="2" y="2" width="18" height="18" fill="none" />
          </clipPath>
          <clipPath id="clip1_3132_35826">
            <rect width="13.5" height="9.9" fill="none" transform="translate(4.69995 5.6001)" />
          </clipPath>
        </defs>
      </svg>
    ) : (
      <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.5" y="1.5" width="19" height="19" rx="0.5" fill="none" stroke={getSemanticTextColor(color)} />
      </svg>
    )}
  </DefaultIconWrapper>
);
